export default __webpack_public_path__ + "static/media/bg5.182931e4.jpg";